<template>
  <Layout>
    <div class="w-full bg-gray-100 py-3">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <ol class="flex items-center text-sm text-gray-500">
          <li>
            <router-link to="/" class="hover:text-primary">Home</router-link>
          </li>
          <li class="before:content-['/'] before:mx-2 text-gray-800">Budgeting</li>
        </ol>
      </div>
    </div>

    <div class="w-full max-w-6xl mx-auto px-4 lg:px-8 py-6">
      <section class="mb-8">
        <h1 class="text-2xl font-bold text-center text-gray-900 mb-4">How much does it cost to start a supermarket?</h1>
        <p class="text-base text-gray-600 text-center leading-relaxed mb-1">
          Berlin Shelves designs within 2 hours by 20 years industry experienced designers.
        </p>
        <p class="text-base text-gray-600 text-center leading-relaxed mb-6">
          After checking, we'll calculate the cost of all supermarket equipment for you.
        </p>
        <img
          src="images/services/Service-Budgeting-1.jpg"
          alt="Budgeting service"
          class="w-full h-auto rounded-lg shadow-md"
        />
      </section>

      <hr class="border-t border-gray-200 w-3/5 mx-auto my-8" />

      <section v-for="(caseItem, index) in budgetingCases" :key="caseItem.id" class="mb-8">
        <div :class="caseItem.id === 1 ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'grid grid-cols-1 gap-4'">
          <div v-for="(img, imgIndex) in caseItem.images" :key="imgIndex" class="overflow-hidden rounded-lg shadow-sm">
            <img :src="img" :alt="caseItem.title" class="w-full h-auto block" />
          </div>
        </div>
        <div v-if="caseItem.description" class="mt-4 text-base text-gray-600 leading-relaxed">
          <p>{{ caseItem.description }}</p>
          <p v-if="caseItem.cost" class="mt-2">
            Total cost of this store is <strong class="text-gray-900">{{ caseItem.cost }}</strong>.
          </p>
        </div>
        <hr v-if="index < budgetingCases.length - 1" class="border-t border-gray-200 w-3/5 mx-auto my-8" />
      </section>

      <hr class="border-t border-gray-200 w-3/5 mx-auto my-8" />

      <section class="mb-8">
        <p class="text-base text-gray-600 text-center leading-relaxed">
          {{ budgetingBottomIntro }}
        </p>
      </section>

      <section v-for="(section, index) in budgetingBottomSections" :key="index" class="mb-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          <div class="md:col-span-2 overflow-hidden rounded-lg shadow-sm">
            <img :src="section.image" :alt="'Section ' + (index + 1)" class="w-full h-auto block" />
          </div>
          <div class="md:col-span-1">
            <p class="text-base text-gray-600 leading-relaxed mb-2">{{ section.description }}</p>
            <p class="text-base text-gray-600 leading-relaxed">
              Total cost of this store is <strong class="text-gray-900">{{ section.cost }}</strong>.
            </p>
          </div>
        </div>
        <hr v-if="index < budgetingBottomSections.length - 1" class="border-t border-gray-200 w-3/5 mx-auto my-8" />
      </section>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";
import { getRequest } from "@/api/api";
import { getImageUrl } from "@/utils/image";

// 静态文案常量（不迁移到数据库，保留在前端）
const BUDGETING_BOTTOM_INTRO = "These supermarkets consists of supermarket shelves/fruit and vegetable rack/convenice store checkout counter/display rack.The following price  for your reference";

export default {
  name: "BudgetingView",
  components: {Layout},
  data() {
    return {
      budgetingCases: [],
      budgetingBottomSections: [],
      budgetingBottomIntro: BUDGETING_BOTTOM_INTRO
    }
  },
  created() {
    this.loadCases();
    this.loadSections();
  },
  methods: {
    async loadCases() {
      try {
        const resp = await getRequest("/api/budgeting/cases");
        if (resp && resp.data && resp.data.data) {
          // 后端 {id, title, description, cost, images[]} → 前端 images 走 getImageUrl 包装
          this.budgetingCases = (resp.data.data || []).map(item => ({
            id: item.id,
            title: item.title,
            description: item.description,
            cost: item.cost,
            images: (item.images || []).map(img => getImageUrl(img))
          }));
        }
      } catch (e) {
        console.error('Failed to load budgeting cases', e);
      }
    },
    async loadSections() {
      try {
        const resp = await getRequest("/api/budgeting/sections");
        if (resp && resp.data && resp.data.data) {
          // 后端 {imageUrl, description, cost} → 前端 {image: getImageUrl包装, description, cost}
          this.budgetingBottomSections = (resp.data.data || []).map(item => ({
            image: item.imageUrl ? getImageUrl(item.imageUrl) : '',
            description: item.description,
            cost: item.cost
          }));
        }
      } catch (e) {
        console.error('Failed to load budgeting sections', e);
      }
    }
  }
}
</script>

